import React from 'react';
import { Outlet } from 'react-router-dom';

const NodesPage = () => <Outlet />;

export default NodesPage;
